var _rect, _path, _path2, _g, _rect2, _path3, _rect3, _path4, _path5, _path6, _path7, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect65, _path17, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanlHubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1489 16.1083C36.1082 15.7678 32.6612 10.2289 31.6337 9.32526L30.4618 7.4232L29.0932 8.58364L29.8713 11.4193L28.0286 14.4056C31.5881 16.1063 34.0678 18.7901 36.1489 16.1083Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17634 32.0851C6.7066 29.993 4.0936 26.2234 3.09581 24.6001L3.33617 21.9871L3.99949 21.3268L5.77196 21.7316L7.07093 23.3282L10.9474 27.0005L11.9966 30.2032C12.0856 31.7022 11.6461 34.1772 9.17634 32.0851Z",
    fill: "#9C9C9C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5179_10928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6963 9.46147C31.6963 9.46147 30.6158 7.71238 28.6563 8.74814C22.747 11.8717 5.19689 21.1329 3.70386 21.9221C1.76004 22.9496 3.08871 24.5833 3.08871 24.5833C3.08871 24.5833 5.01654 23.5642 5.66009 24.3698L10.505 30.4317C11.0724 31.1417 9.21945 32.1211 9.21945 32.1211C9.21945 32.1211 10.4509 33.6351 12.2885 32.6637C18.9265 29.1687 35.8774 20.2085 35.8774 20.2085C35.8774 20.2085 37.615 19.2799 36.7154 17.5869C34.8479 18.5741 34.3635 17.8057 34.3635 17.8057L30.2871 11.3368C29.7527 10.4885 31.6958 9.46137 31.6958 9.46137L31.6963 9.46147Z",
    fill: "#B7B7B7"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.693537,
    height: 0.932075,
    rx: 0.346768,
    transform: "matrix(0.777283 -0.629151 0.722578 0.691289 8.2876 30.1035)",
    fill: "#5B5B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20865 32.0945L9.0249 30.3535L10.9976 30.783L10.4165 32.4098L9.20865 32.0945Z",
    fill: "#B7B7B7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 0.690198,
    height: 0.936926,
    rx: 0.345099,
    transform: "matrix(0.883736 -0.467987 0.57851 0.815675 34.7896 15.9824)",
    fill: "#5B5B5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7288 9.47068L31.4914 7.70756L30.7618 7.71021L29.9134 8.34236L30.3829 9.39186L31.7288 9.47068Z",
    fill: "#B7B7B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66004 23.5722L2.43677 21.7168L3.56277 21.8587L4.00884 22.8955L3.64778 23.7592L2.66004 23.5722Z",
    fill: "#B7B7B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.782 16.4899L36.9697 18.3693L36.6638 18.8214L36.1872 17.611L36.782 16.4899Z",
    fill: "#B7B7B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4857 7.6978C31.4857 7.6978 30.4051 5.9487 28.4456 6.98446C22.5364 10.1081 4.9862 19.3692 3.49316 20.1584C1.54934 21.1859 2.87802 22.8196 2.87802 22.8196C2.87802 22.8196 4.80584 21.8006 5.4494 22.6062L10.2943 28.6681C10.8617 29.378 9.00876 30.3574 9.00876 30.3574C9.00876 30.3574 10.2402 31.8714 12.0779 30.9C18.7158 27.405 35.6667 18.4449 35.6667 18.4449C35.6667 18.4449 37.5193 17.4656 36.5047 15.8232C34.6372 16.8104 34.1528 16.0421 34.1528 16.0421L30.0764 9.57313C29.542 8.7248 31.4851 7.69769 31.4851 7.69769L31.4857 7.6978Z",
    fill: "#ECECEC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 9.74194,
    y: 23.2637,
    width: 6.58398,
    height: 3.29199,
    transform: "rotate(-6.99891 9.74194 23.2637)",
    fill: "url(#pattern0_5179_10928)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9006,
    y: 13.4297,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 26.9006 13.4297)",
    fill: "#C3C3C3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2842,
    y: 13.2188,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 27.2842 13.2188)",
    fill: "#C3C3C3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27.668,
    y: 13.0078,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 27.668 13.0078)",
    fill: "#C3C3C3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0515,
    y: 12.7969,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.0515 12.7969)",
    fill: "#C3C3C3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4351,
    y: 12.5859,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.4351 12.5859)",
    fill: "#C3C3C3"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8188,
    y: 12.375,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.8188 12.375)",
    fill: "#C3C3C3"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2024,
    y: 12.1621,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.2024 12.1621)",
    fill: "#C3C3C3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3,
    y: 13.7012,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 27.3 13.7012)",
    fill: "#C3C3C3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6836,
    y: 13.4902,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 27.6836 13.4902)",
    fill: "#C3C3C3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0671,
    y: 13.2793,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.0671 13.2793)",
    fill: "#C3C3C3"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4509,
    y: 13.0684,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.4509 13.0684)",
    fill: "#C3C3C3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8345,
    y: 12.8574,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.8345 12.8574)",
    fill: "#C3C3C3"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 29.218,
    y: 12.6465,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.218 12.6465)",
    fill: "#C3C3C3"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3157,
    y: 14.1836,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 27.3157 14.1836)",
    fill: "#C3C3C3"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6992,
    y: 13.9727,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 27.6992 13.9727)",
    fill: "#C3C3C3"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0828,
    y: 13.7617,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.0828 13.7617)",
    fill: "#C3C3C3"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4666,
    y: 13.5508,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.4666 13.5508)",
    fill: "#C3C3C3"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8501,
    y: 13.3398,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.8501 13.3398)",
    fill: "#C3C3C3"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2336,
    y: 13.127,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.2336 13.127)",
    fill: "#C3C3C3"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6174,
    y: 12.918,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.6174 12.918)",
    fill: "#C3C3C3"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7148,
    y: 14.4551,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 27.7148 14.4551)",
    fill: "#C3C3C3"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0984,
    y: 14.2441,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.0984 14.2441)",
    fill: "#C3C3C3"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4822,
    y: 14.0332,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.4822 14.0332)",
    fill: "#C3C3C3"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8657,
    y: 13.8223,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.8657 13.8223)",
    fill: "#C3C3C3"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2495,
    y: 13.6113,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.2495 13.6113)",
    fill: "#C3C3C3"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6331,
    y: 13.4004,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.6331 13.4004)",
    fill: "#C3C3C3"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7305,
    y: 14.9375,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 27.7305 14.9375)",
    fill: "#C3C3C3"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1143,
    y: 14.7266,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.1143 14.7266)",
    fill: "#C3C3C3"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4978,
    y: 14.5156,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.4978 14.5156)",
    fill: "#C3C3C3"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8813,
    y: 14.3047,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.8813 14.3047)",
    fill: "#C3C3C3"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2651,
    y: 14.0938,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.2651 14.0938)",
    fill: "#C3C3C3"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6487,
    y: 13.8828,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.6487 13.8828)",
    fill: "#C3C3C3"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0322,
    y: 13.6719,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 30.0322 13.6719)",
    fill: "#C3C3C3"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1299,
    y: 15.209,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.1299 15.209)",
    fill: "#C3C3C3"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5134,
    y: 14.998,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.5134 14.998)",
    fill: "#C3C3C3"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 28.897,
    y: 14.7871,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.897 14.7871)",
    fill: "#C3C3C3"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2808,
    y: 14.5762,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.2808 14.5762)",
    fill: "#C3C3C3"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6643,
    y: 14.3652,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.6643 14.3652)",
    fill: "#C3C3C3"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0479,
    y: 14.1543,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 30.0479 14.1543)",
    fill: "#C3C3C3"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1455,
    y: 15.6914,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.1455 15.6914)",
    fill: "#C3C3C3"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5291,
    y: 15.4805,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.5291 15.4805)",
    fill: "#C3C3C3"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9128,
    y: 15.2695,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.9128 15.2695)",
    fill: "#C3C3C3"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2964,
    y: 15.0586,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.2964 15.0586)",
    fill: "#C3C3C3"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6799,
    y: 14.8477,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.6799 14.8477)",
    fill: "#C3C3C3"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0635,
    y: 14.6367,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 30.0635 14.6367)",
    fill: "#C3C3C3"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4473,
    y: 14.4258,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 30.4473 14.4258)",
    fill: "#C3C3C3"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5603,
    y: 16.4453,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.5603 16.4453)",
    fill: "#C3C3C3"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9441,
    y: 16.2344,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.9441 16.2344)",
    fill: "#C3C3C3"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3276,
    y: 16.0234,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.3276 16.0234)",
    fill: "#C3C3C3"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7112,
    y: 15.8125,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.7112 15.8125)",
    fill: "#C3C3C3"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 30.095,
    y: 15.6016,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 30.095 15.6016)",
    fill: "#C3C3C3"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4785,
    y: 15.3906,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 30.4785 15.3906)",
    fill: "#C3C3C3"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8623,
    y: 15.1797,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 30.8623 15.1797)",
    fill: "#C3C3C3"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5447,
    y: 15.9629,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.5447 15.9629)",
    fill: "#C3C3C3"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9285,
    y: 15.752,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 28.9285 15.752)",
    fill: "#C3C3C3"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 29.312,
    y: 15.541,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.312 15.541)",
    fill: "#C3C3C3"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6956,
    y: 15.3301,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 29.6956 15.3301)",
    fill: "#C3C3C3"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0793,
    y: 15.1191,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 30.0793 15.1191)",
    fill: "#C3C3C3"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4629,
    y: 14.9082,
    width: 0.145959,
    height: 0.358606,
    rx: 0.056,
    transform: "rotate(-28.8238 30.4629 14.9082)",
    fill: "#C3C3C3"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 0.690198,
    height: 0.936926,
    rx: 0.345099,
    transform: "matrix(0.883736 -0.467987 0.57851 0.815675 4.15454 24.8848)",
    fill: "#5B5B5B"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 0.689148,
    height: 0.938596,
    rx: 0.344574,
    transform: "matrix(0.914926 -0.403622 0.520409 0.853917 31.0693 10.3906)",
    fill: "#5B5B5B"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 25.1957,
    height: 0.828108,
    rx: 0.28,
    transform: "matrix(0.883552 -0.468334 0.578985 0.815338 6.63501 22.0117)",
    fill: "#D5D5D5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9238 10.8793L21.9277 10.8864L21.9 10.9017L21.896 10.8946L21.9238 10.8793ZM21.8737 10.848L21.9025 10.9003L21.8935 10.9053L21.8647 10.853L21.8737 10.848ZM21.9073 10.8579L21.9112 10.865L21.8871 10.8783L21.8832 10.8712L21.9073 10.8579ZM21.8987 10.8342L21.9027 10.8414L21.8751 10.8566L21.8711 10.8494L21.8987 10.8342ZM21.9285 10.8178L21.9573 10.8701L21.9484 10.875L21.9195 10.8227L21.9285 10.8178ZM21.9449 10.8087L21.9489 10.8159L21.9072 10.8389L21.9033 10.8317L21.9449 10.8087ZM21.9984 10.8077L22.0023 10.8149L21.9746 10.8302L21.9706 10.823L21.9984 10.8077ZM21.9608 10.8L21.9897 10.8523L21.9806 10.8572L21.9518 10.8049L21.9608 10.8ZM21.9933 10.7821L22.0221 10.8344L22.0131 10.8393L21.9843 10.787L21.9933 10.7821Z",
    fill: "#727272"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8479 23.4416C19.8498 23.4387 19.8514 23.4356 19.8527 23.4323C19.854 23.4289 19.8549 23.4253 19.8552 23.4215L19.8597 23.4182L19.8938 23.4654L19.8875 23.47L19.8597 23.4316C19.8595 23.4325 19.8592 23.4335 19.8588 23.4346C19.8584 23.4357 19.8579 23.4369 19.8573 23.4381C19.8568 23.4392 19.8562 23.4404 19.8555 23.4416C19.8548 23.4428 19.8541 23.4439 19.8534 23.4449L19.8479 23.4416Z",
    fill: "#868686"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7147 22.9801C20.7158 22.9818 20.7167 22.9836 20.7171 22.9856C20.7175 22.9876 20.7178 22.9897 20.7178 22.992C20.7177 22.9942 20.7176 22.9966 20.7172 22.999C20.7169 23.0014 20.7165 23.0038 20.7162 23.0061C20.716 23.0074 20.7157 23.009 20.7154 23.0108C20.7152 23.0126 20.715 23.0144 20.7149 23.0161C20.7148 23.0179 20.7149 23.0196 20.715 23.0211C20.7152 23.0226 20.7155 23.0237 20.7161 23.0244L20.7378 23.0087L20.7417 23.0141L20.7131 23.0348C20.7129 23.0346 20.7126 23.0343 20.7124 23.034C20.7122 23.0338 20.7121 23.0335 20.7119 23.0333C20.7103 23.0312 20.7093 23.0289 20.7086 23.0266C20.708 23.0242 20.7077 23.0218 20.7076 23.0194C20.7076 23.0169 20.7077 23.0145 20.7081 23.012C20.7084 23.0095 20.7088 23.0071 20.7092 23.0048C20.7095 23.0029 20.7098 23.001 20.71 22.9992C20.7103 22.9974 20.7104 22.9957 20.7105 22.9941C20.7105 22.9924 20.7103 22.9908 20.7099 22.9894C20.7096 22.9879 20.709 22.9865 20.7081 22.9852C20.7071 22.9839 20.706 22.9829 20.7049 22.9822C20.7038 22.9816 20.7026 22.9812 20.7015 22.9811C20.7003 22.981 20.6991 22.9812 20.6979 22.9816C20.6967 22.982 20.6956 22.9826 20.6945 22.9834C20.6932 22.9843 20.6921 22.9854 20.6913 22.9865C20.6904 22.9877 20.6898 22.9888 20.6893 22.9899C20.6887 22.991 20.6884 22.992 20.6882 22.993C20.688 22.9939 20.6878 22.9946 20.6877 22.9951L20.6813 22.9929C20.6814 22.9922 20.6816 22.9912 20.6819 22.99C20.6823 22.9887 20.6828 22.9873 20.6835 22.9859C20.6842 22.9845 20.6851 22.9831 20.6862 22.9817C20.6873 22.9802 20.6887 22.9789 20.6903 22.9778C20.6953 22.9742 20.6998 22.9727 20.7039 22.9732C20.7081 22.9736 20.7116 22.976 20.7147 22.9801Z",
    fill: "#868686"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56 22.5772C21.564 22.5742 21.5663 22.5714 21.5669 22.5685C21.5675 22.5657 21.5668 22.5629 21.5649 22.5602C21.5636 22.5585 21.5622 22.5573 21.5606 22.5567C21.5591 22.556 21.5574 22.5558 21.5558 22.5559C21.5541 22.5561 21.5523 22.5566 21.5505 22.5574C21.5488 22.5582 21.5471 22.5592 21.5454 22.5604L21.5438 22.5616L21.54 22.5564L21.5423 22.5548C21.5434 22.554 21.5445 22.553 21.5455 22.552C21.5466 22.5508 21.5474 22.5496 21.548 22.5483C21.5485 22.547 21.5488 22.5456 21.5487 22.5442C21.5486 22.5427 21.5479 22.5411 21.5468 22.5396C21.5459 22.5383 21.5449 22.5374 21.5438 22.5368C21.5427 22.5362 21.5415 22.5359 21.5403 22.5359C21.5392 22.5358 21.538 22.5361 21.5368 22.5366C21.5357 22.537 21.5346 22.5376 21.5335 22.5384C21.5313 22.5399 21.5297 22.5416 21.5286 22.5434C21.5276 22.5451 21.5268 22.5467 21.5262 22.5481L21.5203 22.545C21.5206 22.5443 21.521 22.5434 21.5215 22.5424C21.522 22.5413 21.5227 22.5402 21.5234 22.5391C21.5242 22.538 21.5251 22.5369 21.5261 22.5358C21.5272 22.5346 21.5283 22.5336 21.5296 22.5326C21.5321 22.5308 21.5345 22.5296 21.5368 22.5289C21.539 22.5282 21.5412 22.528 21.5432 22.5282C21.5451 22.5285 21.547 22.5291 21.5487 22.5303C21.5503 22.5313 21.5518 22.5328 21.5531 22.5345C21.5549 22.537 21.5557 22.5396 21.5556 22.5424C21.5554 22.5451 21.5547 22.5477 21.5533 22.55C21.5548 22.5495 21.5564 22.5492 21.558 22.549C21.5596 22.5489 21.5612 22.549 21.5628 22.5495C21.5644 22.5499 21.566 22.5506 21.5675 22.5516C21.569 22.5526 21.5704 22.5539 21.5716 22.5556C21.5731 22.5576 21.5741 22.5598 21.5746 22.5621C21.5752 22.5643 21.5752 22.5666 21.5746 22.5689C21.5741 22.5712 21.573 22.5736 21.5713 22.5759C21.5696 22.5782 21.5672 22.5805 21.5642 22.5827C21.563 22.5836 21.5617 22.5844 21.5603 22.5851C21.559 22.5858 21.5576 22.5864 21.5563 22.5869C21.5551 22.5875 21.5539 22.5879 21.5529 22.5882C21.5519 22.5885 21.5511 22.5887 21.5506 22.5888L21.5479 22.5824C21.5489 22.5822 21.5505 22.5818 21.5527 22.5811C21.555 22.5803 21.5574 22.579 21.56 22.5772Z",
    fill: "#868686"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3784 22.1293C22.3778 22.1267 22.3773 22.1235 22.3769 22.1198C22.3765 22.1161 22.3762 22.1121 22.376 22.108C22.3759 22.1038 22.3759 22.0995 22.376 22.0953C22.3762 22.091 22.3766 22.0869 22.3772 22.0832L22.3833 22.0788L22.405 22.1087L22.4106 22.1047L22.4143 22.1099L22.4087 22.1139L22.4175 22.1259L22.4113 22.1304L22.4026 22.1183L22.3815 22.1336L22.3784 22.1293ZM22.3826 22.0907C22.3823 22.0932 22.3821 22.0958 22.382 22.0986C22.3819 22.1014 22.3819 22.1042 22.382 22.1071C22.3821 22.11 22.3823 22.1129 22.3826 22.1158C22.383 22.1187 22.3834 22.1214 22.3839 22.124L22.3989 22.1132L22.3826 22.0907Z",
    fill: "#868686"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2197 21.6635C23.2267 21.6588 23.2328 21.6567 23.238 21.6571C23.2431 21.6575 23.2474 21.66 23.2508 21.6647C23.2523 21.6668 23.2534 21.669 23.2539 21.6713C23.2545 21.6735 23.2546 21.6758 23.254 21.6782C23.2535 21.6804 23.2525 21.6827 23.2508 21.685C23.2492 21.6873 23.2468 21.6896 23.2439 21.6918C23.2427 21.6926 23.2414 21.6934 23.2401 21.6941C23.2387 21.6948 23.2374 21.6954 23.2362 21.6959C23.2349 21.6964 23.2338 21.6968 23.2328 21.6971C23.2318 21.6974 23.231 21.6976 23.2305 21.6977L23.2278 21.6913C23.2288 21.6911 23.2304 21.6907 23.2325 21.69C23.2347 21.6893 23.2371 21.688 23.2396 21.6862C23.2417 21.6847 23.2432 21.6833 23.2442 21.6818C23.2453 21.6804 23.246 21.6789 23.2463 21.6775C23.2466 21.6761 23.2466 21.6748 23.2462 21.6735C23.2459 21.6722 23.2453 21.671 23.2445 21.6698C23.2432 21.6681 23.2418 21.6668 23.2403 21.6659C23.2387 21.665 23.2368 21.6646 23.2347 21.6648C23.2325 21.665 23.23 21.6657 23.2272 21.6671C23.2244 21.6684 23.221 21.6704 23.2172 21.6732C23.2159 21.6708 23.2146 21.6685 23.2133 21.6665C23.2121 21.6644 23.2109 21.6624 23.2096 21.6604C23.2084 21.6585 23.2072 21.6565 23.206 21.6547C23.2047 21.6527 23.2034 21.6507 23.202 21.6486L23.2247 21.6322L23.2286 21.6375L23.2114 21.65C23.2119 21.6507 23.2125 21.6517 23.2132 21.6529C23.214 21.6541 23.2148 21.6554 23.2156 21.6567C23.2164 21.658 23.2172 21.6593 23.2179 21.6605C23.2187 21.6618 23.2193 21.6628 23.2197 21.6635Z",
    fill: "#868686"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0573 21.235C24.054 21.2304 24.0517 21.2259 24.0504 21.2215C24.0492 21.217 24.0488 21.2128 24.0494 21.2087C24.05 21.2046 24.0515 21.2007 24.0539 21.1971C24.0564 21.1934 24.0596 21.19 24.0638 21.1869L24.0681 21.1919C24.0655 21.1939 24.0632 21.196 24.0614 21.1981C24.0596 21.2002 24.0583 21.2025 24.0574 21.2049C24.0566 21.2074 24.0562 21.21 24.0564 21.2127C24.0566 21.2154 24.0574 21.2184 24.0588 21.2216C24.0596 21.2202 24.0606 21.2188 24.0618 21.2174C24.063 21.2159 24.0644 21.2146 24.066 21.2135C24.0687 21.2115 24.0712 21.2103 24.0737 21.2097C24.0761 21.2092 24.0784 21.2092 24.0806 21.2097C24.0827 21.2102 24.0847 21.2111 24.0865 21.2125C24.0883 21.2138 24.0898 21.2155 24.0912 21.2174C24.0925 21.2191 24.0935 21.2211 24.0942 21.2233C24.0949 21.2255 24.0952 21.2279 24.0951 21.2302C24.095 21.2326 24.0943 21.2349 24.0932 21.2372C24.092 21.2395 24.0901 21.2416 24.0876 21.2434C24.0824 21.2472 24.0772 21.2483 24.0719 21.2467C24.0667 21.2451 24.0618 21.2412 24.0573 21.235ZM24.0691 21.2191C24.0675 21.2203 24.0661 21.2215 24.065 21.2228C24.0638 21.2241 24.0628 21.2255 24.0618 21.227C24.0621 21.2276 24.0625 21.2281 24.0628 21.2287C24.0632 21.2292 24.0636 21.2297 24.0639 21.2302C24.0654 21.2322 24.0669 21.234 24.0684 21.2356C24.07 21.2371 24.0716 21.2383 24.0732 21.2392C24.0749 21.24 24.0766 21.2404 24.0784 21.2403C24.0802 21.2403 24.0819 21.2396 24.0837 21.2382C24.0852 21.2372 24.0863 21.2359 24.0869 21.2345C24.0874 21.2331 24.0877 21.2317 24.0877 21.2302C24.0876 21.2287 24.0873 21.2273 24.0868 21.226C24.0862 21.2246 24.0856 21.2233 24.0848 21.2222C24.0826 21.2191 24.0801 21.2173 24.0774 21.2168C24.0748 21.2162 24.072 21.217 24.0691 21.2191Z",
    fill: "#868686"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9174 20.8056C24.9151 20.8018 24.9129 20.7975 24.911 20.7928C24.9092 20.788 24.9076 20.7832 24.9064 20.7783C24.9051 20.7734 24.9042 20.7688 24.9036 20.7642C24.9031 20.7597 24.9029 20.7557 24.9032 20.7524L24.8802 20.7691L24.8763 20.7636L24.9062 20.7418L24.91 20.747C24.9098 20.7499 24.9099 20.7534 24.9103 20.7578C24.9106 20.7621 24.9113 20.7667 24.9124 20.7717C24.9135 20.7765 24.915 20.7815 24.917 20.7866C24.9189 20.7917 24.9212 20.7964 24.924 20.8008L24.9174 20.8056Z",
    fill: "#868686"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7717 20.331C25.7731 20.3329 25.774 20.3349 25.7745 20.337C25.775 20.3391 25.7751 20.3412 25.7746 20.3434C25.7742 20.3455 25.7733 20.3476 25.7718 20.3496C25.7703 20.3517 25.7683 20.3537 25.7658 20.3555C25.7628 20.3576 25.7601 20.359 25.7575 20.3596C25.7549 20.3602 25.7526 20.3603 25.7505 20.3599C25.7484 20.3594 25.7465 20.3587 25.7449 20.3575C25.7433 20.3563 25.742 20.3551 25.741 20.3537C25.7401 20.3524 25.7394 20.351 25.7389 20.3495C25.7385 20.348 25.7383 20.3464 25.7382 20.3449C25.7382 20.3433 25.7383 20.3418 25.7386 20.3403C25.7389 20.3388 25.7394 20.3373 25.74 20.3359C25.7337 20.3366 25.7288 20.3345 25.7252 20.3295C25.7239 20.3278 25.7231 20.3259 25.7226 20.3239C25.7222 20.3218 25.7221 20.3197 25.7225 20.3177C25.7229 20.3156 25.7238 20.3135 25.725 20.3116C25.7263 20.3096 25.728 20.3078 25.7302 20.3062C25.7327 20.3044 25.7352 20.3032 25.7375 20.3026C25.7399 20.3021 25.7421 20.302 25.7441 20.3024C25.7462 20.3027 25.7479 20.3035 25.7495 20.3045C25.7511 20.3056 25.7524 20.3068 25.7534 20.3082C25.7543 20.3095 25.755 20.3109 25.7555 20.3123C25.7559 20.3137 25.7562 20.3152 25.7562 20.3167C25.7563 20.3181 25.7562 20.3196 25.7559 20.321C25.7556 20.3223 25.7553 20.3236 25.7548 20.3249C25.762 20.3235 25.7676 20.3256 25.7717 20.331ZM25.7475 20.3492C25.7481 20.35 25.7488 20.3507 25.7498 20.3514C25.7507 20.3521 25.7518 20.3525 25.7531 20.3528C25.7544 20.353 25.7557 20.3529 25.7572 20.3526C25.7587 20.3522 25.7603 20.3515 25.7621 20.3502C25.7636 20.3491 25.7648 20.3479 25.7656 20.3466C25.7664 20.3453 25.767 20.3441 25.7672 20.3429C25.7674 20.3416 25.7674 20.3404 25.7671 20.3392C25.7668 20.3381 25.7663 20.337 25.7656 20.336C25.7645 20.3346 25.7633 20.3335 25.762 20.3328C25.7607 20.3321 25.7592 20.3317 25.7576 20.3317C25.756 20.3316 25.7542 20.3318 25.7524 20.3323C25.7506 20.3327 25.7486 20.3334 25.7465 20.3343C25.7453 20.3369 25.7447 20.3395 25.7448 20.342C25.7449 20.3444 25.7458 20.3468 25.7475 20.3492ZM25.747 20.3127C25.7465 20.312 25.7458 20.3114 25.7449 20.3108C25.744 20.3102 25.743 20.3097 25.7419 20.3095C25.7407 20.3093 25.7395 20.3093 25.7382 20.3095C25.7368 20.3098 25.7354 20.3104 25.734 20.3114C25.7325 20.3125 25.7314 20.3136 25.7307 20.3148C25.73 20.316 25.7297 20.3172 25.7295 20.3184C25.7294 20.3195 25.7295 20.3206 25.7298 20.3217C25.7301 20.3227 25.7306 20.3237 25.7312 20.3245C25.7319 20.3255 25.7328 20.3263 25.7339 20.3271C25.735 20.3278 25.7362 20.3283 25.7376 20.3286C25.739 20.3289 25.7405 20.329 25.7423 20.3288C25.744 20.3285 25.7459 20.328 25.7479 20.3271C25.749 20.3246 25.7496 20.3222 25.7496 20.3199C25.7496 20.3175 25.7488 20.3151 25.747 20.3127Z",
    fill: "#868686"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6195 19.8984C26.6173 19.8969 26.6151 19.8954 26.613 19.894C26.6109 19.8925 26.6087 19.891 26.6065 19.8895L26.5852 19.9049L26.5896 19.9201L26.5827 19.9251C26.5809 19.9188 26.5793 19.9129 26.5778 19.9075C26.5763 19.9021 26.5749 19.897 26.5737 19.8921C26.5724 19.8872 26.5713 19.8824 26.5703 19.8779C26.5693 19.8733 26.5684 19.8688 26.5675 19.8642L26.5736 19.8598C26.5777 19.862 26.5817 19.8643 26.5858 19.8667C26.5898 19.8691 26.5939 19.8716 26.5982 19.8743C26.6025 19.877 26.6069 19.8799 26.6116 19.8831C26.6163 19.8861 26.6213 19.8895 26.6267 19.8932L26.6195 19.8984ZM26.6007 19.8854C26.5964 19.8825 26.5921 19.8797 26.588 19.8771C26.5839 19.8744 26.5799 19.8719 26.5759 19.8696C26.5767 19.8742 26.5778 19.8789 26.579 19.8836C26.5803 19.8883 26.5817 19.8931 26.5831 19.8981L26.6007 19.8854Z",
    fill: "#868686"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4579 19.4568C27.457 19.4575 27.4559 19.4582 27.4548 19.459C27.4536 19.4598 27.4525 19.4605 27.4513 19.4612C27.4501 19.4619 27.449 19.4626 27.4478 19.4633C27.4466 19.4639 27.4455 19.4644 27.4444 19.4649L27.4113 19.4192C27.412 19.4183 27.4129 19.4174 27.4139 19.4165C27.4148 19.4155 27.4159 19.4146 27.4169 19.4138C27.4179 19.4128 27.419 19.412 27.4201 19.4111C27.4211 19.4103 27.4221 19.4095 27.4231 19.4088C27.4258 19.4069 27.4285 19.4052 27.4311 19.4039C27.4338 19.4026 27.4364 19.4018 27.4388 19.4016C27.4413 19.4012 27.4436 19.4015 27.4458 19.4024C27.4479 19.4032 27.4498 19.4048 27.4515 19.4071C27.4534 19.4097 27.4543 19.4123 27.4543 19.4149C27.4543 19.4174 27.4535 19.4198 27.4521 19.4221C27.4554 19.4209 27.4585 19.4206 27.4615 19.4212C27.4644 19.4218 27.467 19.4237 27.4693 19.4269C27.4728 19.4316 27.4736 19.4364 27.4718 19.4413C27.4701 19.4462 27.4655 19.4514 27.4579 19.4568ZM27.4355 19.4389L27.4476 19.4555C27.4481 19.4552 27.4487 19.4548 27.4494 19.4544C27.4501 19.454 27.4508 19.4535 27.4516 19.453C27.4524 19.4524 27.4533 19.4518 27.4544 19.451C27.4563 19.4496 27.4581 19.4482 27.4596 19.4467C27.4612 19.4451 27.4624 19.4436 27.4633 19.442C27.4641 19.4404 27.4645 19.4387 27.4645 19.437C27.4645 19.4353 27.4638 19.4336 27.4626 19.4319C27.4615 19.4303 27.4602 19.4293 27.4589 19.4286C27.4575 19.428 27.456 19.4277 27.4544 19.4279C27.4529 19.4281 27.4512 19.4286 27.4495 19.4294C27.4478 19.4303 27.4459 19.4314 27.444 19.4328L27.4355 19.4389ZM27.4317 19.4336L27.4386 19.4286C27.4403 19.4274 27.4417 19.4262 27.443 19.4249C27.4443 19.4236 27.4452 19.4223 27.4459 19.421C27.4465 19.4196 27.4468 19.4182 27.4467 19.4168C27.4466 19.4154 27.4461 19.414 27.445 19.4125C27.4441 19.4112 27.4429 19.4103 27.4416 19.4098C27.4403 19.4093 27.4389 19.4092 27.4373 19.4095C27.4358 19.4097 27.4342 19.4102 27.4325 19.411C27.4308 19.4118 27.4291 19.4128 27.4275 19.4141C27.4258 19.4153 27.4245 19.4163 27.4236 19.417C27.4227 19.4177 27.4218 19.4184 27.4211 19.4191L27.4317 19.4336Z",
    fill: "#868686"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5864,
    y: 25.377,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 18.5864 25.377)",
    fill: "#838383",
    fillOpacity: 0.96
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6954 24.5671C18.7705 24.6939 18.7294 24.8593 18.6011 24.9353C18.4727 25.0114 18.3088 24.9694 18.2328 24.841C18.1895 24.7679 18.1826 24.6813 18.2152 24.6036C18.2217 24.5876 18.2406 24.5785 18.2575 24.5866C18.2735 24.5931 18.2826 24.612 18.2746 24.6289C18.2493 24.6883 18.2548 24.7556 18.2874 24.8107C18.3449 24.9077 18.4707 24.9399 18.5677 24.8825C18.6647 24.825 18.6969 24.6992 18.6395 24.6022C18.6067 24.5469 18.5513 24.5113 18.4862 24.5035C18.469 24.5016 18.4554 24.4856 18.4573 24.4682C18.4592 24.451 18.4753 24.4374 18.4926 24.4393C18.5779 24.4472 18.6521 24.494 18.6954 24.5671ZM18.4357 24.7208L18.2855 24.4671C18.2767 24.4522 18.2815 24.4333 18.2964 24.4245C18.3114 24.4156 18.3303 24.4205 18.3391 24.4354L18.4894 24.6891C18.4982 24.704 18.4933 24.7229 18.4784 24.7318C18.4659 24.7412 18.4446 24.7357 18.4357 24.7208Z",
    fill: "#868686"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3706,
    y: 24.4316,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 20.3706 24.4316)",
    fill: "#838383"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2102,
    y: 23.9863,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 21.2102 23.9863)",
    fill: "#838383"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0498,
    y: 23.541,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 22.0498 23.541)",
    fill: "#838383"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8894,
    y: 23.0957,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 22.8894 23.0957)",
    fill: "#838383"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7292,
    y: 22.6504,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 23.7292 22.6504)",
    fill: "#838383"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5686,
    y: 22.2051,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 24.5686 22.2051)",
    fill: "#838383"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4084,
    y: 21.7617,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 25.4084 21.7617)",
    fill: "#838383"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 26.248,
    y: 21.3145,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 26.248 21.3145)",
    fill: "#838383"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0876,
    y: 20.8711,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 27.0876 20.8711)",
    fill: "#838383"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9272,
    y: 20.4258,
    width: 0.356374,
    height: 0.831539,
    rx: 0.084,
    transform: "rotate(-35.9329 27.9272 20.4258)",
    fill: "#838383"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5179_10928",
    x: 2.53351,
    y: 8.36392,
    width: 34.5524,
    height: 24.7924,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.056
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.056
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5179_10928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5179_10928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5179_10928",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5179_10928",
    transform: "scale(0.0135135 0.027027)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5179_10928",
    width: 74,
    height: 37,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAlCAMAAADSrI/MAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAgFQTFRFAAAASUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJ6BGOSgAAAKt0Uk5TADaxFlj/hwbR8UCMyOK8YhI4EH/f9brA1OA0rSi/znofTOnqHSK1Ao/v9JREBUifl1QKoPfFeHQgCS4O3YDrYP1yGWjXCGVCgiPjU8PYKZNwfi38FHlQO088jeeebpClDOa3+cHT+v4TZDqnsHXVdkehVsIlqCz7AdLkBPOYPjDwA47LHMe27q41JvZeqjKsBzep3hdz7c8NlWxFWmGziokkarhVg8S7mx6vpLwQPgAAAqhJREFUeJytlPtfEkEUxW/hjaAsXSA1WdpQ06WAFPJFCCX20oKizEoqtDSz7GlZllLZw6zMyuz9Lqu/slmQ3NldBBbPD8veuzPn851hzgBkqyVLNVnPSaE8XLZYVtrlulyx9CtW5q9aXQBQmBsWYzCiaU1RMZasBShFs2ofPYtoWceR1/XWsnKoMG2oVGWkr+LRtnGTPVE50AmwGR1qnEoJUHXNfO1ymwnWFjVYtVhH1fXIZo3VYG4UfjzWrTVU30tsNE2ZYzE+1o/Ib9suYDXTn/hAC2nuyMwosdM7HbuM+buVsHzknO4pEPfsrW0+BSADi7a26vg/xhTtZaBZCUscH/u+oA35kMzJbkHLfi5ZHQh7AQLWg9SQUBwrGR/ukAWRbWcUVne4wy6qSngGjviP0kOMx5g5LHtrJwHySnyYyPETddJEnIwiwerqbqS6ejSA9pROwwVPI+/US+YIO91j6u3pPEO1+7CbYJ3199OjWXJOC7GMLCwkBSJhdZ/zNVSWnzcNiLyYC7qBi1ilhEXic4n3yoBIWAPeuaVdxv/7IoBeuQqDWA/XritgaSU+YODR7WpvSZZDN24OJ0B5vOXqGAIwu0lSbnePULNGpTstKBTwUd3+GDl7d+724r3asUTHiXoYa7ovn5pODx6SxyA+Gh9Odh5PsEJ8nmTrlIdPAZ7h5HNRL0iwZPFJp6kXppevAKaxVdz1vJ6Rp3pBvZmOhm1vOfL2Dt9TXyIkKZ7JD5n6fPwURksfFy9G8PP8l3hYZzIGmvoSJbfK12T4tMWx5EHlIinDqqhvYdv3anGIf+DPOJBiWBcUw/+SdGZjFaAc1nQSLkZK4xOzFoWwZoQVaKE7v1EeVpVYf9T5EDFGKZZ6+VB+zasVy2e/xSkUvxgXSX+7ctytfyt5c4nZP/u0AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanlHubIcon);
export default __webpack_public_path__ + "static/media/panl_hubIcon.91e2cd23299bda6e4b54e94a671c6e8f.svg";
export { ForwardRef as ReactComponent };